module.exports = "../dist/img/img_3-25.f7ff.jpg";